import { ErrorMessage } from "formik";
import { useState } from "react";
import AutoSuggest from "react-autosuggest";
import "./reactAutoSuggest.css";

const CustomInputAutoSuggest = ({
  field,
  form: { touched, errors, setFieldValue },
  label,
  placeholder,
  required,
  options,
  onChange,
  onSuggestionSelected,
  noMarginBottom,
  ...props
}) => {
  //const [value, setValue] = useState(field?.value);
  const [suggestions, setSuggestions] = useState(options);

  function getSuggestions(value) {
    return options.filter((x) =>
      x.name?.toLowerCase().includes(value.trim().toLowerCase())
    );
  }

  return (
    <div className={`${noMarginBottom == true ? "" : "mb-2"}`}>
      {label && (
        <label className="mb-1">
          {label} {required && <span className="text-danger">*</span>}
        </label>
      )}
      <AutoSuggest
        suggestions={suggestions}
        onSuggestionsClearRequested={() => setSuggestions([])}
        onSuggestionsFetchRequested={({ value }) => {
          //console.log(value);
          //setValue(value);
          setFieldValue(field.name, value ?? "");
          setSuggestions(getSuggestions(value));
        }}
        // onSuggestionSelected={(_, { suggestionValue }) => {
        //   //console.log("Selected: " + suggestionValue);
        //   setFieldValue(field.name, suggestionValue ?? "");
        // }}
        onSuggestionSelected={(_, { suggestion }) => {
          //console.log("Selected: " + suggestion);
          if (onSuggestionSelected) {
            onSuggestionSelected(suggestion);
          } else {
            setFieldValue(field.name, suggestion?.name ?? "");
          }
        }}
        // getSuggestionValue={(suggestion) => suggestion.name}
        getSuggestionValue={(suggestion) => suggestion}
        renderSuggestion={(suggestion) => <span>{suggestion.name}</span>}
        inputProps={{
          ...props,
          className: "form-control form-control-sm",
          placeholder: placeholder,
          //value: value,
          value: field?.value,
          // onChange: (_, { newValue, method }) => {
          //   //setValue(newValue);
          //   setFieldValue(field.name, newValue ?? "");
          // },
          onChange: (_, { newValue, method }) => {
            //setValue(newValue);
            //console.log("onChange: ", newValue);
            if (onChange) {
              onChange(newValue, method);
            } else {
              setFieldValue(field.name, newValue?.name ?? "");
            }
          },
        }}
        highlightFirstSuggestion={true}
      />
      <ErrorMessage
        name={field.name}
        component="div"
        className="invalid-feedback animated fadeInUp"
        style={{ display: "block" }}
      />
    </div>
  );
};

export default CustomInputAutoSuggest;
